var jrs = {
  
  page_paginate:24,
  start:0,
 
  search_option: function(){
    
    if($('#ProductJson-search').html() != undefined ){
      var productSearch = JSON.parse($('#ProductJson-search').html());
      show_value(productSearch);
    }
      
    
      $('body').on('click', '.page_paginate .paging', function(){
      
        
        var start = parseInt($(this).attr('data-var'));
        var total_li = Math.ceil(productSearch.length/jrs.page_paginate);
        
          if(typeof start !== 'undefined' & start !=0 & start !=(total_li+1)){
            start -=1;
            if(jrs.start !=start){          
              jrs.start = start*jrs.page_paginate;            
              show_value(productSearch);
            }
          }
        
        
                      
      });
    
    $('body').on('change', '.search_short_by select.sort-by', function(){
      	var short = $(this).val();
       
        if(short == 'title-ascending'){            
          	productSearch.sort(function (a, b) {
              var nameA = a.product_name.toUpperCase(); 
              var nameB = b.product_name.toUpperCase();
              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }
              return 0;             
            });
          } else if(short == 'title-descending'){
          	productSearch.sort(function (a, b) {
              var nameA = a.product_name.toUpperCase();
              var nameB = b.product_name.toUpperCase(); 
              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }
            
              return 0;          
            }).reverse();
          
        } else if(short == 'price-ascending'){
          	productSearch.sort(function (a, b) {
              return a.product_price -  b.product_price;              
            });
          
        } else if(short == 'price-descending'){
          	productSearch.sort(function (a, b) {
              return a.product_price -  b.product_price;              
            }).reverse();
        }
      
         show_value(productSearch);
      	 
      
    });
      
        function show_value(result){
          
            var end = jrs.start + jrs.page_paginate -1;          
            var show_product = '';
             $.each(result, function (index, value) {
                 if(jrs.start <= index){
                    show_product +='<li class="innerresults" data-no="'+index+'">'+
                      				'<div class="prod-th">'+
                        				'<div class="res-image-inner" search-product-img>'+
                      						 '<a href="'+ value.product_url+'" title="'+value.product_name +'">'+
                      							'<img src="'+value.product_img+'" alt="'+value.product_name +'"/>'+
                                              '</a>'+
                        				 '</div>'; 

                     show_product +='<div class="product-title">'+
                       				'<h4 search-product-title>'+
                     					'<a href="'+ value.product_url+'" title="'+value.product_name +'">'+value.product_name+'</a>'+
                                     '</h4>'+
                          			'<p search-paroduct-price>'+
                       					'<span class=price-money>'+Sunrise.Currency.formatMoney(value.product_price, Sunrise.strings.money_format)+'</span>'+
                     				  '</p>'+
                        			'</div>'+
                      			'</div>'+
                    			'</li>';
                    
                 }
               
               if(index == end){return false;}
             });
          
          	  if(show_product != '' ){
                 $('.show_results_search').html(show_product);
               }
               
          
			   // paging 
          
               var paging = '';               
               var total_li = Math.ceil(result.length/jrs.page_paginate);
               var total_last = total_li - 3;
               var current_pagging =  parseInt(end/jrs.page_paginate);
                 
           if(total_li > 8 ){
             
               if(current_pagging < 3 ){
                 
                	 paging += '<span class="paging" data-var="'+current_pagging+'"> < </span>';
                 	 paging += '<span class="paging" data-var="1">1</span>';
                     paging += '<span class="paging" data-var="2">2</span>';
                     paging += '<span class="paging" data-var="3">3</span>';
                     paging += '<span class="paging" data-var="4">4</span>';
                 	 paging += '<span class="paging">...</span>';
                 	 paging += '<span class="paging" data-var="'+total_li+'">'+total_li+'</span>';
                     paging += '<span class="paging" data-var="'+(current_pagging+2)+'"> > </span>';
                 
               } else if( current_pagging >= 3 & current_pagging <= total_last ){
                 	 paging += '<span class="paging" data-var="'+current_pagging+'"> < </span>';
                     paging += '<span class="paging" data-var="1">1</span>';
                     paging += '<span class="paging" data-var="2">2</span>';
                 
                 	 paging += '<span class="paging">...</span>';
                 
                     paging += '<span class="paging" data-var="'+current_pagging+'">'+current_pagging+'</span>';
                     paging += '<span class="paging" data-var="'+(current_pagging + 1)+'">'+(current_pagging + 1)+'</span>';
                     paging += '<span class="paging" data-var="'+(current_pagging +2)+'">'+(current_pagging + 2)+'</span>';
                 
                 	 paging += '<span class="paging">...</span>';
                 
                     paging += '<span class="paging" data-var="'+total_li+'">'+total_li+'</span>';
                 	 paging += '<span class="paging" data-var="'+(current_pagging+2)+'"> > </span>';
                 	
               }else{
                 	 paging += '<span class="paging" data-var="'+current_pagging+'"> < </span>';
                	 paging += '<span class="paging" data-var="1">1</span>';
                 	 paging += '<span class="paging">...</span>';
                     paging += '<span class="paging" data-var="'+(total_li-2)+'">'+(total_li-2)+'</span>';
                     paging += '<span class="paging" data-var="'+(total_li-1)+'">'+(total_li-1)+'</span>';
                 	 paging += '<span class="paging" data-var="'+total_li+'">'+total_li+'</span>'; 
                 	 paging += '<span class="paging" data-var="'+(current_pagging+2)+'"> > </span>';
                 }
               }
               else{
                 for(var i=1; i<=total_li; i+=1){
                   paging += '<span class="paging" data-var="'+i+'">'+i+'</span>';
                 }  
               }
                
               $('.page_paginate').html(paging);
               add_active_paging(current_pagging);                
        }
    
        function add_active_paging(cp){
           $('.page_paginate .paging[data-var="'+(cp+1)+'"]').addClass('active');
        }
  },
  cart_round: function(){
    
    $('body').on('click', '.go_to_checkout', function(e){
      
      if($('form.checkout_form_btn').hasClass('add_donate_product')){
        $('.loader_img').show();
        e.preventDefault();
        
        var cartPrice = parseInt($('form.checkout_form_btn').attr('cart-price'))/100;
        var addPrice = 10 - cartPrice;
        $('form #textbox_amount[name="textbox_amount"]').val(addPrice);
        $('form .donation_button').trigger("click");
        submit_url($(this));
        $('form.checkout_form_btn').removeClass('add_donate_product');
        
      }
    });
    
    function submit_url(that){
      setTimeout(function(){
        	that.trigger("click");
      },100);
    }
  },
  remove_round_product(id){
     jQuery.post('/cart/update.js', 'updates['+id+']=0').done(function() {
    		 window.location.href='/cart';
     });
     
  }
  
  
}

$(function(){
  
  jrs.search_option();
  jrs.cart_round();
  
});